<template>
  <vx-card class="mt-base" :title="activityTitle">
    <h4 class="mb-5">Build Your Own Room Alarm</h4>
    <p class="mb-5">
      As we mentioned in the previous activity, one of the best ways to learn about electrical
      engineering is by completing some practical projects.
    </p>
    <p class="mb-5">
      While the following projects will use lower voltages, it’s still important to use caution at
      all times. Working with electricity even at low voltages can be dangerous when proper safety
      procedures are not followed.
    </p>
    <p class="mb-5">
      In this project, you will learn how to make a room alarm that will be triggered when someone
      opens the door.
    </p>
    <p class="mb-5">
      Before you get started, you will need to gather together the following materials:
    </p>
    <ul class="default-list">
      <li>1x 9V battery</li>
      <li>1x 9V battery clip</li>
      <li>1x 9V buzzer</li>
      <li>1x spring-loaded clothes peg</li>
      <li>15cm of duct tape/aluminium tape</li>
      <li>1x 20cm x 10cm chipboard</li>
      <li>25mm x 25mm Square of Double-Sided Foam Tape</li>
      <li>Approximately 30cm of string</li>
      <li>Masking tape</li>
      <li>Scissors</li>
      <li>Hole Punch</li>
      <li>Ruler</li>
      <li>Pencil</li>
    </ul>
    <p class="mb-5">
      You’ll find more details about the items you’ll need for this project in the downloadable PDF.
    </p>
    <p class="mb-5">
      Once you’ve gathered up all the necessary items to make your electrical room alarm, you can
      follow the steps in the PDF or watch the video below, pausing it and rewatching sections as
      you need to.
    </p>

    <div class="vx-row mb-5">
      <div class="vx-col lg:w-1/2">
        <button
          type="button"
          class="no-style img-click-button"
          aria-label="Play video: Room alarm demonstration (no audio)"
          @click="openVideoPopup(videos['1'].video)"
        >
          <img :src="videos['1'].image" class="img-responsive cursor-pointer w-full" alt="" />
        </button>
        <p class="text-center">(This video intentionally has no audio)</p>
      </div>
      <div class="vx-col lg:w-1/2">
        <a :href="'content/engineering/room_alarm_instructions.pdf' | blob_url" target="_blank">
          <centered-image-wrapper
            alt="Room alarm instructions (PDF) (opens in a new tab)"
            :image="require('@/assets/images/experiences/engineering/instructions_button.png')"
            classes="3/3"
          />
        </a>
      </div>
    </div>

    <p class="mb-5">
      Once you have completed your room alarm, take a picture of it in position - armed and ready!
    </p>
    <p class="mb-5">Upload your photo here:</p>
    <fileupload-button-immediate
      v-model="uploaded_files['uploaded_file_1']"
      :is-editable="isEditable"
      filetype="photo_doc"
      upload-btn-text="Upload Photo"
    />

    <save-buttons :is-editable="isEditable" @save="save" />
  </vx-card>
</template>

<script>
import methods from '@/views/WorkExperiences/components/activity_js/methods';
import computed from '@/views/WorkExperiences/components/activity_js/computed';
import inject from '@/views/WorkExperiences/components/activity_js/inject';
import store from '../../../../store/store';
export default {
  data() {
    return {
      videos: {
        1: {
          image: require('@/assets/images/experiences/engineering/room_alarm_video_trigger.jpg'),
          video: 'https://www.youtube.com/embed/9DrHyUT7LtM?autoplay=1',
        },
      },
      uploaded_files: {
        uploaded_file_1: '',
      },
    };
  },
  methods: {
    ...methods,
    openVideoPopup(video) {
      store.dispatch('popup/showVideoPopup', video);
    },
  },
  computed: computed,
  inject: inject,
  mounted() {
    for (let i = 1; i <= 1; i++) {
      if (typeof this.data['uploaded_file_' + i] !== 'undefined') {
        this.uploaded_files['uploaded_file_' + i] = this.data['uploaded_file_' + i];
      }
    }
  },
};
</script>
